import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import FocusableButton from '../FocusableButton';

export default function Day(props) {
  const {
    today,
    selected,
    between = false,
    forward,
    backward,
    luxon,
    available,
    ...rest
  } = props || {};
  const onMouseDownCapture = React.useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  return (
    <FocusableButton
      {...ex(['Day', { today, selected, between, forward, backward, available, disabled: !available }], rest)}
      {...{
        'data-year': luxon?.year,
        'data-month': luxon?.month,
        'data-day': luxon?.day,
        'data-weekday': luxon?.weekday,
        onMouseDownCapture,
      }}
    >
      <div>
        {luxon?.day}
      </div>
    </FocusableButton>
  );
}
